import React, { Component } from 'react';
import { set as queryStoreActionSet } from 'forepaas/store/querystring/action';
import { set as sessionStoreActionSet } from 'forepaas/store/session/action';
import FpTranslate from 'forepaas/translate';
import _isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class DynamicSelectBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      model: null,
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.sessionStore[this.props.id]) {
      const valArray = this.props.sessionStore[this.props.id];
      this.updateModel(valArray[0]);
    }
    if (!this.props.querystring[this.props.id]) {
      if (this.props.default) {
        process.nextTick(() => {
          this.initDefaultState();
        });
      } else if (
        !this.state.model &&
        this.props.notEmpty &&
        this.props.items &&
        this.props.items.length > 0 &&
        this.props.items[0].value
      ) {
        this.updateModel(this.props.items[0].value);
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let model = null;
    if (nextProps.id && nextProps.querystring[nextProps.id]) {
      const queryValue = nextProps.querystring[nextProps.id];
      if (queryValue && Array.isArray(queryValue) && queryValue.length > 0) {
        const value = queryValue[0];
        const foundItem = nextProps.items.find(item => _isEqual(item.value, value));
        if (foundItem) {
          model = foundItem;
        }
      }
    }
    if (!_isEqual(model, prevState.model)) return { model };
    return null;
  }

  initDefaultState() {
    let def = this.props.default;
    if (!Array.isArray(def)) {
      def = [def];
    }

    const foundItem = this.props.items.find(item => item.value === def[0]);
    if (foundItem) {
      this.updateModel(foundItem.value);
    }
  }

  updateModel(value, cb) {
    if (this.props.id) {
      const valueArray = value !== null ? [value] : null;
      this.props.dispatch(
        queryStoreActionSet(this.props.id, valueArray)
      );
      this.props.dispatch(
        sessionStoreActionSet(this.props.id, valueArray)
      );
      
      const foundItem = this.props.items.find(item => item.value === value);
      this.setState({ model: foundItem || null });
      if (cb) process.nextTick(cb);
    }
  }

  getValue() {
    return this.state.model ? this.state.model.value : null;
  }

  onChange(e) {
    const value = e.value;
    if (value === 'dynamic-parameter-loading') {
      return;
    }
    
    // If notEmpty, we prevent clearing the selection
    if (this.props.notEmpty && !value) {
      return;
    }
    
    this.updateModel(value);
  }

  get items() {
    const { loading, items, sortBy } = this.props;
    if (loading) {
      return [
        {
          label: FpTranslate('Loading...'),
          value: 'dynamic-parameter-loading',
        },
      ];
    }
    if (!items) return [];
    if (sortBy === 'none') return items;
    let sortOption = sortBy || 'label';
    let cmp = 1;

    if (sortOption[0] === '-') {
      cmp = -1;
      sortOption = sortOption.slice(1);
    }
    return items.sort((a, b) => {
      if (a[sortOption] > b[sortOption]) return cmp;
      if (a[sortOption] < b[sortOption]) return -cmp;
      return 0;
    });
  }

  render() {
    const placeholder = this.props.placeholder
      ? FpTranslate(this.props.placeholder)
      : FpTranslate('Select...');

    const val = this.getValue();

    return (
      <div className={`figma-dropdown ${this.props.customclass || ''}`}>
        <Dropdown
          value={val}
          options={this.items}
          onChange={this.onChange}
          placeholder={placeholder}
          optionLabel="label"
          optionValue="value"
          className="sidebar-dropdown"
          style={{ width: '100%' }}
          disabled={this.props.loading}
        />
      </div>
    );
  }
}

DynamicSelectBox.propTypes = {
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  customclass: PropTypes.string,
  notEmpty: PropTypes.bool,
  searchable: PropTypes.bool,
  items: PropTypes.array,
  dropdownIcon: PropTypes.string,
  default: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array,
  ]),
  multi: PropTypes.bool,
  id: PropTypes.string,
  loading: PropTypes.bool,
  querystring: PropTypes.object,
  placeholder: PropTypes.string,
  dispatch: PropTypes.func,
  sortBy: PropTypes.string,
  selectedMessage: PropTypes.string,
};
export default DynamicSelectBox;
